import grafikart from "../../../assets/img/youtube/french/grafikart.webp";
import captaindev from "../../../assets/img/youtube/french/captaindev.webp";
import graven from "../../../assets/img/youtube/french/graven.webp";
import formationvideo from "../../../assets/img/youtube/french/formationvideo.webp";
import designerduweb from "../../../assets/img/youtube/french/designerduweb.webp";
import donkeygeek from "../../../assets/img/youtube/french/donkeygeek.webp";
import devtheory from "../../../assets/img/youtube/french/devtheory.webp";
import devlibre from "../../../assets/img/youtube/french/devlibre.webp";
import benjamincode from "../../../assets/img/youtube/french/benjamincode.webp";
import harryjmg from "../../../assets/img/youtube/french/harryjmg.webp";
import frerecodeur from "../../../assets/img/youtube/french/frerecodeur.webp";
import mikecodeur from "../../../assets/img/youtube/french/mikecodeur.webp";
import lior from "../../../assets/img/youtube/french/lior.webp";
import johntaieb from "../../../assets/img/youtube/french/johntaieb.webp";

export const DataFrench = [
  {
    icon: grafikart,
    cName: "icon",
    title: "Grafikart.fr",
    path: "https://www.youtube.com/c/grafikart/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: captaindev,
    cName: "icon",
    title: "Captain Dev",
    path: "https://www.youtube.com/channel/UCuWaYcB0E0WyFjbvu7dalVw/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: graven,
    cName: "icon",
    title: "Graven - Développement ",
    path: "https://www.youtube.com/c/Gravenilvectuto/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: formationvideo,
    cName: "icon",
    title: "FormationVidéo",
    path: "https://www.youtube.com/c/Formationvid%C3%A9o8/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: designerduweb,
    cName: "icon",
    title: "Le Designer du Web",
    path: "https://www.youtube.com/c/LeDesignerduWeb/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: donkeygeek,
    cName: "icon",
    title: "Donkey Geek",
    path: "https://www.youtube.com/c/DonkeyGeek/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: devtheory,
    cName: "icon",
    title: "Dev Theory",
    path: "https://www.youtube.com/c/DevTheory/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: devlibre,
    cName: "icon",
    title: "Développeur Libre",
    path: "https://www.youtube.com/c/D%C3%A9veloppeurLibre/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: benjamincode,
    cName: "icon",
    title: "Benjamin Code",
    path: "https://www.youtube.com/c/BenjaminCode/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: harryjmg,
    cName: "icon",
    title: "Harry JMG",
    path: "https://www.youtube.com/c/HarryJMG/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: frerecodeur,
    cName: "icon",
    title: "Les Frères Codeurs",
    path: "https://www.youtube.com/c/MaxAlexLesfrèrescodeurs/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: mikecodeur,
    cName: "icon",
    title: "Mike / Codeur Nomade",
    path: "https://www.youtube.com/c/MikeCodeurNomade/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: lior,
    cName: "icon",
    title: "Lior CHAMLA",
    path: "https://www.youtube.com/c/LiorCHAMLA/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
  {
    icon: johntaieb,
    cName: "icon",
    title: "John Taieb",
    path: "https://www.youtube.com/c/JohnTaieb/featured",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repudiandae perspiciatis labore accusamus esse cupiditate eveniet, accusantium hic reprehenderit laborum totam voluptas quisquam, aspernatur iste nostrum praesentium distinctio.",
  },
];
